<template>
</template>
<script>
export default {
  data() {
    let vm = this;
    return {
      element: null,
      resources: {
        zIndex: {
          name: 'zIndex',
          defaultValue: '',
          labelDesc: 'zIndex',
          callback: function() {
            vm.resources.zIndex.defaultValue = this.value;
            vm.element.internal_config.zIndex = this.value;
          }
        },

        padding: {
          name: 'padding',
          defaultLeft: '15',
          defaultTop: '15',
          defaultRight: '15',
          defaultBottom: '15',
          min: '0',
          max: '100',
          labelDesc: 'padding',
          callback: function () {
            vm.resources.padding.defaultLeft = this.l;
            vm.element.internal_config.paddingLeft = this.l + 'px';

            vm.resources.padding.defaultTop = this.t;
            vm.element.internal_config.paddingTop = this.t + 'px';

            vm.resources.padding.defaultRight = this.r;
            vm.element.internal_config.paddingRight = this.r + 'px';

            vm.resources.padding.defaultBottom = this.b;
            vm.element.internal_config.paddingBottom = this.b + 'px';
          },
        },
        maxWidth: {
          name: 'maxWidth',
          defaultValue: '500',
          min: '200',
          max: '768',
          labelDesc: 'max-width-tablet',
          callback: function() {
            vm.resources.maxWidth.defaultValue = this.value;
            vm.element.internal_config.maxWidth = this.value + 'px';
          }
        },

        withRegards: {
          name: 'withRegards',
          defaultValue: '0',
          defaultOptions: [
            {
              name: 'without-regard',
              value: '0'
            },
            {
              name: 'with-regard',
              value: '1'
            }
          ],
          labelDesc: 'config-regard',
          callback: function() {
            vm.resources.withRegards.defaultValue = this.value;
            vm.element.internal_config.withRegards = this.value;
          }
        },

        withDropdown: {
          name: 'withDropdown',
          defaultValue: '1',
          defaultOptions: [
            {
              name: 'with-dropdown',
              value: '1'
            },
            {
              name: 'without-dropdown',
              value: '0'
            }
          ],
          labelDesc: 'config-dropdown',
          callback: function() {
            vm.resources.withDropdown.defaultValue = this.value;
            vm.element.internal_config.withDropdown = this.value;
          }
        },

        textLogin: {
          name: 'textLogin',
          defaultValue: vm.$t('ct-login'),
          labelDesc: 'text-login',
          callback: function() {
            vm.resources.textLogin.defaultValue = this.value.trim();
            vm.element.internal_config.textLogin = this.value.trim();
          }
        },

        textRegister: {
          name: 'textRegister',
          defaultValue: vm.$t('ct-register'),
          labelDesc: 'text-register',
          callback: function() {
            vm.resources.textRegister.defaultValue = this.value;
            vm.element.internal_config.textRegister = this.value;
          }
        },

        textLogout: {
          name: 'textLogout',
          defaultValue: vm.$t('ct-logout'),
          labelDesc: 'text-logout',
          callback: function() {
            vm.resources.textLogout.defaultValue = this.value.trim();
            vm.element.internal_config.textLogout = this.value.trim();
          }
        },

        textRegards: {
          name: 'textRegards',
          defaultValue: vm.$t('ct-hello') + ',',
          labelDesc: 'text-regards',
          callback: function() {
            vm.resources.textRegards.defaultValue = this.value.trim();
            vm.element.internal_config.textRegards = this.value.trim();
          }
        },

        /* Icons  - Begin */
        iconLogin: {
          name: 'iconLogin',
          defaultIcon: '',
          defaultPosition: 'left',
          labelDesc: 'icon-login',
          canRemove: true,
          callback: function() {
            vm.setIcon('iconLogin', this.iconSelected, this.position);
          }
        },

        iconRegister: {
          name: 'iconRegister',
          defaultIcon: '',
          defaultPosition: 'left',
          labelDesc: 'icon-register',
          canRemove: true,
          callback: function() {
            vm.setIcon('iconRegister', this.iconSelected, this.position);
          }
        },

        iconLogout: {
          name: 'iconLogout',
          defaultIcon: '',
          defaultPosition: 'left',
          labelDesc: 'icon-logout',
          canRemove: true,
          callback: function() {
            vm.setIcon('iconLogout', this.iconSelected, this.position);
          }
        },

        iconRegards: {
          name: 'iconRegards',
          defaultIcon: '',
          defaultPosition: 'left',
          labelDesc: 'icon-regards',
          canRemove: true,
          callback: function() {
            vm.setIcon('iconRegards', this.iconSelected, this.position);
          }
        },
        /* Icons - End */

        actionsformat: {
          name: 'actionsformat',
          defaultValue: 'login-register',
          defaultOptions: [
            {
              name: 'login-register',
              value: 'login-register'
            },
            {
              name: 'only-register',
              value: 'register'
            },
            {
              name: 'only-login',
              value: 'login'
            }
          ],
          labelDesc: 'actions-format',
          callback: function() {
            vm.resources.actionsformat.defaultValue = this.value;
            vm.element.internal_config.actionsformat = this.value;
          }
        },

        // Styles
        btnUserTextStyle: {
          name: 'btnUserTextStyle',
          defaultFamily: '',
          defaultSize: '',
          showSizeMobile: true,
          shitOptions: true,
          defaultSizeMobile: '15px',
          defaultColor: '',
          defaultAlign: '',
          defaultWeight: '',
          defaultStroke: '',
          defaultStyle: '',
          labelDesc: 'btnUserTextStyle',
          callback: function() {
            vm.setTextStyle('buttonStyle', 'btnUserTextStyle', this);
          }
        },

        dropdownUserTextStyle: {
          name: 'dropdownUserTextStyle',
          defaultFamily: '',
          defaultSize: '',
          showSizeMobile: true,
          shitOptions: true,
          defaultSizeMobile: '15px',
          defaultColor: '',
          defaultAlign: '',
          defaultWeight: '',
          defaultStroke: '',
          defaultStyle: '',
          labelDesc: 'dropdown-user-textstyle',
          callback: function() {
            vm.setTextStyle('dropdownStyle', 'dropdownUserTextStyle', this);
          }
        },

        border: {
          name: 'border',
          defaultValue: '1px solid black',
          min: '0',
          max: '50',
          labelDesc: 'border',
          callback: function() {
            let value = this.value + 'px ' + this.value2 + ' ' + this.value3;

            vm.resources.border.defaultValue = value;
            vm.element.internal_config.buttonStyle.border = value;
          }
        },

        dropdownBorder: {
          name: 'dropdownBorder',
          defaultValue: '1px solid black',
          min: '0',
          max: '50',
          labelDesc: 'dropdown-border',
          callback: function() {
            let value = this.value + 'px ' + this.value2 + ' ' + this.value3;

            vm.resources.dropdownBorder.defaultValue = value;
            vm.element.internal_config.dropdownStyle.border = value;
          }
        },

        borderRadius: {
          name: 'borderRadius',
          defaultValue: '0 0 0 0',
          min: '0',
          max: '360',
          labelDesc: 'borderRadius',
          callback: function() {
            let value = this.v1 + 'px ' + this.v2 + 'px ' + this.v3 + 'px ' + this.v4 + 'px';

            vm.resources.borderRadius.defaultValue = value;
            vm.element.internal_config.buttonStyle.borderRadius = value;
          }
        },

        dropdownBorderRadius: {
          name: 'dropdownBorderRadius',
          defaultValue: '0 0 0 0',
          min: '0',
          max: '360',
          labelDesc: 'dropdownBorderRadius',
          callback: function() {
            let value = this.v1 + 'px ' + this.v2 + 'px ' + this.v3 + 'px ' + this.v4 + 'px';

            vm.resources.dropdownBorderRadius.defaultValue = value;
            vm.element.internal_config.dropdownStyle.borderRadius = value;
          }
        },

        boxShadow: {
          name: 'boxShadow',
          defaultValue: '0 0 0 0 black initial',
          min: '0',
          max: '50',
          labelDesc: 'boxShadow',
          callback: function() {
            let value = this.h + 'px ' + this.v + 'px ' + this.b + 'px ' + this.s + 'px ' + this.colorValue + ' ' + (this.i === true ? 'inset' : '');

            vm.resources.boxShadow.defaultValue = value;
            vm.element.internal_config.buttonStyle.boxShadow = value;
          }
        },

        dropdownBoxShadow: {
          name: 'dropdownBoxShadow',
          defaultValue: '0 0 0 0 black initial',
          min: '0',
          max: '50',
          labelDesc: 'dropdownBoxShadow',
          callback: function() {
            let value = this.h + 'px ' + this.v + 'px ' + this.b + 'px ' + this.s + 'px ' + this.colorValue + ' ' + (this.i === true ? 'inset' : '');

            vm.resources.dropdownBoxShadow.defaultValue = value;
            vm.element.internal_config.dropdownStyle.boxShadow = value;
          }
        },

        backgroundColor: {
          name: 'backgroundColor',
          defaultValue: '#ffffff',
          labelDesc: 'resource-bg-color',
          callback: function() {
            vm.resources.backgroundColor.defaultValue = this.colorValue;
            vm.element.internal_config.buttonStyle.backgroundColor = this.colorValue;
          }
        },
        backgroundColorHover: {
          name: 'backgroundColorHover',
          defaultValue: '#ffffff',
          labelDesc: 'resource-bg-color-hover',
          callback: function() {
            vm.resources.backgroundColorHover.defaultValue = this.colorValue;
            vm.element.internal_config.buttonStyle.backgroundColorHover = this.colorValue;
          }
        },

        backgroundDropdownColor: {
          name: 'backgroundDropdownColor',
          defaultValue: '#ffffff',
          labelDesc: 'dropdown-bg-color',
          callback: function() {
            vm.resources.backgroundDropdownColor.defaultValue = this.colorValue;
            vm.element.internal_config.dropdownStyle.backgroundColor = this.colorValue;
          }
        },
        backgroundDropdownColorHover: {
          name: 'backgroundDropdownColorHover',
          defaultValue: '#ffffff',
          labelDesc: 'dropdown-bg-color-hover',
          callback: function() {
            vm.resources.backgroundDropdownColorHover.defaultValue = this.colorValue;
            vm.element.internal_config.dropdownStyle.backgroundColorHover = this.colorValue;
          }
        },

        textColorHover: {
          name: 'textColorHover',
          defaultValue: '#ffffff',
          labelDesc: 'text-color-hover',
          callback: function() {
            vm.resources.textColorHover.defaultValue = this.colorValue;
            vm.element.internal_config.buttonStyle.textColorHover = this.colorValue;
          }
        },

        textColorHoverDropdown: {
          name: 'textColorHoverDropdown',
          defaultValue: '#ffffff',
          labelDesc: 'dropdown-text-color-hover',
          callback: function() {
            vm.resources.textColorHoverDropdown.defaultValue = this.colorValue;
            vm.element.internal_config.dropdownStyle.textColorHover = this.colorValue;
          }
        }
      }
    };
  },
  methods: {
    setIcon(type, icon = '', position) {
      this.resources[type].defaultIcon = icon;
      this.resources[type].defaultPosition = position;

      this.element.internal_config[type] = Object.assign({}, this.element.internal_config[type], {
        icon: icon,
        position: position
      });
    },

    setTextStyle(type, resourceName, config) {
      let vm = this;

      this.resources[resourceName] = Object.assign({}, vm.resources[resourceName], {
        defaultFamily: config.family,
        defaultSize: config.size + 'px',
        defaultSizeMobile: config.sizeMobile + 'px',
        defaultColor: config.color,
        defaultAlign: config.align,
        weight: config.weight,
        defaultStyle: config.style,
        defaultStroke: config.stroke
      });

      this.element.internal_config[type].textStyle = Object.assign({}, vm.element.internal_config[type].textStyle, {
        family: config.family,
        size: config.size + 'px',
        sizeMobile: config.sizeMobile + 'px',
        color: config.color,
        align: config.align,
        weight: config.weight,
        style: config.style,
        stroke: config.stroke
      });
    },

    setResourceTextStyle(resourceName, textStyle) {
      this.resources[resourceName].defaultFamily = textStyle.family;
      this.resources[resourceName].defaultSize = textStyle.size;
      this.resources[resourceName].defaultSizeMobile = textStyle.sizeMobile;
      this.resources[resourceName].defaultColor = textStyle.color;
      this.resources[resourceName].defaultAlign = textStyle.align;
      this.resources[resourceName].defaultWeight = textStyle.weight;
      this.resources[resourceName].defaultStyle = textStyle.style;
      this.resources[resourceName].defaultStroke = textStyle.stroke;
    },

    setResourceIcon(resourceName, config){
      this.resources[resourceName].defaultIcon = config.icon;
      this.resources[resourceName].defaultPosition = config.position;
    },
    setValuesData(data) {

      this.element = data;

      this.resources.maxWidth.defaultValue = parseInt(data.internal_config.maxWidth);

      if (data.internal_config.actionsformat) { this.resources.actionsformat.defaultValue = data.internal_config.actionsformat }

      if (data.internal_config.textLogin) { this.resources.textLogin.defaultValue = data.internal_config.textLogin }

      if (data.internal_config.textLogout) { this.resources.textLogout.defaultValue = data.internal_config.textLogout }

      if (data.internal_config.textRegister) { this.resources.textRegister.defaultValue = data.internal_config.textRegister }

      if (data.internal_config.textRegards) { this.resources.textRegards.defaultValue = data.internal_config.textRegards }

      if (data.internal_config.withDropdown) { this.resources.withDropdown.defaultValue = data.internal_config.withDropdown }

      if (data.internal_config.withRegards) { this.resources.withRegards.defaultValue = data.internal_config.withRegards }

      this.setResourceIcon('iconLogin', data.internal_config.iconLogin);
      this.setResourceIcon('iconRegister', data.internal_config.iconRegister);
      this.setResourceIcon('iconLogout', data.internal_config.iconLogout);
      this.setResourceIcon('iconRegards', data.internal_config.iconRegards);

      this.setResourceTextStyle('btnUserTextStyle', data.internal_config.buttonStyle.textStyle);
      this.setResourceTextStyle('dropdownUserTextStyle', data.internal_config.dropdownStyle.textStyle);

      this.resources.border.defaultValue = data.internal_config.buttonStyle.border;
      this.resources.borderRadius.defaultValue = data.internal_config.buttonStyle.borderRadius;
      this.resources.boxShadow.defaultValue = data.internal_config.buttonStyle.boxShadow;

      this.resources.backgroundColor.defaultValue = data.internal_config.buttonStyle.backgroundColor;
      this.resources.backgroundColorHover.defaultValue = data.internal_config.buttonStyle.backgroundColorHover;

      this.resources.dropdownBorder.defaultValue = data.internal_config.dropdownStyle.border;
      this.resources.dropdownBorderRadius.defaultValue = data.internal_config.dropdownStyle.borderRadius;
      this.resources.dropdownBoxShadow.defaultValue = data.internal_config.dropdownStyle.boxShadow;

      this.resources.textColorHover.defaultValue = data.internal_config.buttonStyle.textColorHover;
      this.resources.backgroundColor.defaultValue = data.internal_config.buttonStyle.backgroundColor;
      this.resources.backgroundColorHover.defaultValue = data.internal_config.buttonStyle.backgroundColorHover;

      this.resources.textColorHoverDropdown.defaultValue = data.internal_config.dropdownStyle.textColorHover;
      this.resources.backgroundDropdownColor.defaultValue = data.internal_config.dropdownStyle.backgroundColor;
      this.resources.backgroundDropdownColorHover.defaultValue = data.internal_config.dropdownStyle.backgroundColorHover;
    },
    getValuesData() {
      return this.resources;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/Members/ButtonUser/Resources.vue